import {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import Results from './Results';
import { executeFilter, getVideosFilterLength } from '../../actions/filterActions';
import { useParams } from 'react-router-dom'

function FilterResults(props) {

    const {error, loading, filterResults, page, info} = useSelector(state => state.filterResults)

    const {filterList} = useParams()

    const [lst, setLst] = useState([])

    const [filterPage, setFilterPage] = useState(page === undefined ? 1 : page)

    useEffect(()=>{
        localStorage.setItem("path", `/filter_results/${encodeURI(filterList)}`)
        let l = filterList.split('|').map(fl => fl.split('!').map(i => parseInt(i)))
        let new_l = l.map(([a, b]) => [a, " ", b])

        setLst(new_l)
        window.scrollTo(0, 0)
    },[filterList])


    return (
        <>
        {
            lst.length && 
            <Results
                data = {filterResults}
                title = {"FILTER RESULTS"}
                loading = {loading}
                error = {error}
                setVideo = {props.setVideo}
                filterActive = {props.filterActive}
                setFilterActive = {props.setFilterActive}
                searchFunc = {executeFilter}
                lengthFunc = {getVideosFilterLength}
                val = {lst}
                page = {filterPage}
                setPage = {setFilterPage}
                info = {info}
            />
        }
        </>
    );

}

export default FilterResults;